import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const Power = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      width={size}
      height={size}
      fill="none"
      color={iconColor}
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 25 25"
      className="feather feather-power"
    >
      <title>{iconTitle}</title>
      <path d="M18.36 6.64a9 9 0 1 1-12.73 0M12 2v10" />
    </svg>
  );
};

Power.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

Power.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(Power);
